import axios from "axios";
import config from "./config";
import Cookies from "js-cookie";
// const uri = "http://41.73.6.101:8091/api"
// const uri = "http://41.73.6.101:2207/api";
// const uri = "http://41.73.6.101:3000/api";
// const uri = "http://41.73.6.101:8091/api";
// const uri = "https://irep.0ps.tech/api";
const uri = "https://irep.hordun.tech/api ";
// const uri = "https://d1aa-2c0f-2a80-ee-6610-00-5db.ngrok-free.app";

const Axios = axios.create({
  baseURL: "https://irep.hordun.tech/api",
  withCredentials: true,
  withXSRFToken: true,
});

// Intercept request
Axios.interceptors.request.use(
  (config) => {
    const accessToken = Cookies.get("accessToken");

    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// Response interceptor to handle token expiration
Axios.interceptors.response.use(
  (response) => {
    // If the response is successful, simply return the response
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // navigate to signin
    if (
      error.response &&
      error.response.status === 401 &&
      error.response?.data?.message === "Unauthenticated."
    ) {
      if (
        window.location.pathname !== "/logout" &&
        window.location.pathname !== "/sign-in"
      )
        window.location.href = "/auth/sign-in";
    }

    // If the error is not due to token expiration or retry fails, reject the error
    return Promise.reject(error);
  }
);

export const BaseURL = uri;
export default Axios;
